export const MAIN_SECTION_ID = 'pageContentMain';

export const COMPANY_START_DATE = 2013;
